(function() { window.GUID_4a68e5bc_3380_49a2_aadd_44938ad73bb9 = { getGuid: function() { return "4a68e5bc-3380-49a2-aadd-44938ad73bb9"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-messages",
                        callback: (accordion, e) => {
                            accordion.$Content.offon("click.pinResults", "#button-pin-results", (e) => {
                                const $btn = $(e.currentTarget);
                                const { pinUrl, successmsg } = $btn.data("html");
                                if (pinUrl != null) {
                                    accordion.pinSection(pinUrl, accordion, () => {
                                        if (!CS.Helper.isNullOrWhiteSpace(successmsg)) {
                                            CS.Controls.Snackbar.Show({
                                                Id: "pin-toggle-success",
                                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                                Type: CS.Enumeration.SnackbarType.Success,
                                                Message: successmsg,
                                                AutoHideDuration: 3000,
                                            });
                                        }
                                    });
                                }
                            });
                            CS.Controls.Filters.Events.ResetButtonClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-messages-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const refreshUrlHiddenInput = $(`#refresh-with-reset-url-${accordion.ContentId}`);
                                    if ((refreshUrlHiddenInput === null || refreshUrlHiddenInput === void 0 ? void 0 : refreshUrlHiddenInput.val()) != null) {
                                        CS.Nav.Go(refreshUrlHiddenInput.val());
                                    }
                                    else {
                                        accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                            yield CS.Controls.Filters.UpdateFiltersStateInBrowserUrlStatic(e.data.filtersStateSerialized);
                                        }), e.data.resetUrl);
                                        const $parentPopup = $(`#popup-filters-drawer-filters-messages-${accordion.ContentId}-bar`);
                                        const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                        if (parentPopup != null)
                                            parentPopup.Close();
                                    }
                                },
                            });
                            CS.Controls.FiltersBar.Events.ChipClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-messages-${accordion.ContentId}-bar`,
                                callback: (filtersBar, e) => {
                                    if (filtersBar.uiFreezed)
                                        return;
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        const $lazyloadingUrl = $("#LazyloadingUrl");
                                        if ($lazyloadingUrl.length) {
                                            accordion.Data.RefreshUrl = $lazyloadingUrl.val();
                                        }
                                        yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), e.data.toggleUrl);
                                },
                            });
                            CS.Controls.Filters.Events.FiltersToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-messages-${accordion.ContentId}-bar`,
                                callback: (filters, e) => __awaiter(this, void 0, void 0, function* () {
                                    if (e.data.filtersStateSerialized)
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-messages-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                }),
                            });
                            CS.Controls.Filters.Events.ItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-messages-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        const $lazyloadingUrl = $("#LazyloadingUrl");
                                        if ($lazyloadingUrl.length) {
                                            accordion.Data.RefreshUrl = $lazyloadingUrl.val();
                                        }
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), e.data.url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-messages-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.Controls.Filters.Events.FilterToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-messages-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        const $lazyloadingUrl = $("#LazyloadingUrl");
                                        if ($lazyloadingUrl.length) {
                                            accordion.Data.RefreshUrl = $lazyloadingUrl.val();
                                        }
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), e.data.toggleUrl);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-messages-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
